import React, {FC} from "react"
import {MarkdownAtom, MarkdownAtomType} from "../../model/markdown/MarkdownText"
import {AtomSeparator} from "./AtomSeparator"
import {AtomViewer} from "./AtomViewer"

interface AtomsViewerProps {
    atoms: Array<MarkdownAtom>
    separator?: React.ReactNode
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const AtomsViewer: FC<AtomsViewerProps> = ({
                                                      atoms,
                                                      separator,
                                                      onToggleCheckBox
                                                  }) => {
    return (
        <>
            {atoms.map((atom, index) => (
                <React.Fragment key={atom.id}>
                    <AtomViewer atom={atom} onToggleCheckBox={onToggleCheckBox}/>
                    <AtomSeparator index={index}
                                   count={atoms.length}
                                   separator={separator}
                                   current={atom.type}
                                   next={(index >= atoms.length - 1) ? MarkdownAtomType.PLAIN : atoms[index + 1].type}
                    />
                </React.Fragment>
            ))}
        </>
    )
}
